import { INACTIVE_CELL_OPACITY } from './constants';

interface ResolveRatingOpacityProps {
  hasSelectedCell: boolean;
  hasRatingOnlyFilter: boolean;
  isRatingOnSelectedAxis: boolean;
  isRatingActive: boolean;
}

interface ResolveCellOpacityProps {
  hasSelectedCell: boolean;
  hasRatingOnlyFilter: boolean;
  isActive: boolean;
  isOnSelectedAxis: boolean;
  isOnSelectedRating: boolean;
}

export const resolveRatingOpacity = ({
  hasSelectedCell,
  hasRatingOnlyFilter,
  isRatingOnSelectedAxis,
  isRatingActive,
}: ResolveRatingOpacityProps) => {
  if (hasSelectedCell) {
    return isRatingOnSelectedAxis ? 1 : INACTIVE_CELL_OPACITY;
  }

  if (hasRatingOnlyFilter) {
    return isRatingActive ? 1 : INACTIVE_CELL_OPACITY;
  }

  return 1;
};

export const resolveCellOpacity = ({
  hasSelectedCell,
  hasRatingOnlyFilter,
  isActive,
  isOnSelectedAxis,
  isOnSelectedRating,
}: ResolveCellOpacityProps) => {
  if (hasSelectedCell) {
    if (isActive || isOnSelectedAxis) {
      return 1;
    }

    return INACTIVE_CELL_OPACITY;
  }

  if (hasRatingOnlyFilter) {
    return isOnSelectedRating ? 1 : INACTIVE_CELL_OPACITY;
  }

  return 1;
};
